import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteReminderRes } from "./helper";

const deleteReminder = async (id: number) =>
  axios.delete(Routes.DELETE_REMINDER + "/" + id);

export const useDeleteReminder = () =>
  useMutation({
    mutationKey: [Keys.DELETE_REMINDER_MUT],
    mutationFn: deleteReminder,
    onSuccess: (res) => {
      onDeleteReminderRes(res);
      return res;
    },
  });
